import React, { type ReactElement, type ReactNode } from 'react';

import classnames from 'classnames';

import styles from './AdditionalActions.module.scss';

type AdditionalActionsProps = {
    children: ReactNode;
    className?: string;
};

const AdditionalActions = ({ children, className }: AdditionalActionsProps): ReactElement => {
    return <div className={classnames(styles.container, className)}>{children}</div>;
};

export default AdditionalActions;
